/* Terralite: the 1% nonprofit picker in the cart drawer, in Pipeline's own "popout" dropdown (theme setting
   cart_nonprofit_popout). The Pledgeling app injects a native <select id="plgNonprofit"> and posts the choice to
   /cart/update on its change event. This builds a <popout-select> from that select's options next to it, hides the
   app's block visually, and on a pick sets the select's value and fires change so the app still does the update.
   The popout is inserted outside the app's render root so its re-renders never touch it. Worklog: 2026-09-27. */
(function () {
  'use strict';
  if (window.tlNonprofitPopout) return;
  window.tlNonprofitPopout = true;

  var CHEVRON = '<svg xmlns="http://www.w3.org/2000/svg" stroke-linecap="square" stroke-linejoin="arcs" aria-hidden="true" class="icon-theme icon-theme-stroke icon-core-chevron-down" viewBox="0 0 24 24"><path d="m6 9 6 6 6-6"/></svg>';

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }

  function build(root, select) {
    if (root.getAttribute('data-tl-np-built')) return;
    root.setAttribute('data-tl-np-built', '1');
    var options = Array.prototype.slice.call(select.options);
    var current = options[select.selectedIndex] || options[0];
    var id = 'tl-np-list-' + Math.random().toString(36).slice(2, 8);
    var items = options.map(function (o) {
      var label = o.textContent.trim();
      var isCur = o === current;
      return '<li class="popout-list__item' + (isCur ? ' popout-list__item--current' : '') + '"><a class="popout-list__option" href="#"' + (isCur ? ' aria-current="true"' : '') + ' data-value="' + esc(label) + '" data-popout-option><span>' + esc(label) + '</span></a></li>';
    }).join('');
    /* Insert as parsed HTML: Pipeline's PopoutSelect does its setup in the constructor, which for a parsed fragment
       runs after the children exist. createElement would run it on an empty element and throw. */
    var html = '<popout-select class="tl-np"><div class="popout" data-popout data-popout-prevent="true">' +
      '<button type="button" class="popout__toggle tl-np__toggle" aria-expanded="false" aria-controls="' + id + '" data-popout-toggle>' + esc(current.textContent.trim()) + CHEVRON + '</button>' +
      '<ul id="' + id + '" class="popout-list" data-popout-list>' + items + '</ul>' +
      '<input type="hidden" value="' + esc(current.textContent.trim()) + '" data-popout-input></div></popout-select>';
    root.insertAdjacentHTML('afterend', html);
    var wrap = root.nextElementSibling;
    if (!wrap || wrap.tagName.toLowerCase() !== 'popout-select') return;
    root.classList.add('tl-np-native');
    var input = wrap.querySelector('[data-popout-input]');
    input.addEventListener('change', function () {
      var label = input.value;
      var match = options.filter(function (o) { return o.textContent.trim() === label; })[0];
      if (!match || select.value === match.value) return;
      select.value = match.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
    /* The app's select forgets the choice on reload while the cart still carries it (attribute "Nonprofit").
       Read the cart and show the real choice; set the select first so the sync above does not post again. */
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var ein = cart && cart.attributes && cart.attributes.Nonprofit;
      if (!ein) return;
      var match = options.filter(function (o) { return o.value === ein; })[0];
      if (!match || select.value === match.value) return;
      select.value = match.value;
      var link = Array.prototype.filter.call(wrap.querySelectorAll('[data-popout-option]'), function (a) { return a.getAttribute('data-value') === match.textContent.trim(); })[0];
      if (link) link.dispatchEvent(new CustomEvent('theme:popout:click', { bubbles: true, cancelable: true, detail: { preventTrigger: true } }));
    }).catch(function () {});
  }

  function tryBuild() {
    var roots = document.querySelectorAll('[data-select-nonprofit-via-pledgeling]');
    var done = 0;
    Array.prototype.forEach.call(roots, function (root) {
      var select = root.querySelector('select#plgNonprofit, select');
      if (select && select.options.length) { build(root, select); done++; }
    });
    return done === roots.length && roots.length > 0;
  }

  function start() {
    if (tryBuild()) return;
    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      if (tryBuild() || tries > 60) clearInterval(timer);
    }, 250);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
